module.exports = __webpack_public_path__ + "img/valera-lutfullina-judgement.52dd9ad8.jpg";